import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * Wraps the app with Lenis momentum smooth-scrolling.
 */
export default function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Allow anchor links to scroll smoothly via lenis
    const handleAnchor = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (!target) return;
      const id = target.getAttribute('href');
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -20 });
        }
      }
    };
    document.addEventListener('click', handleAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener('click', handleAnchor);
      lenis.destroy();
    };
  }, []);

  return children;
}
